/*
 * Purpose : Home Navigator with Icon component
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import React from "react";
import {NavLink} from "react-router-dom"
import { withRouter } from "react-router";
import { Button } from "reactstrap";
import Aux from "../../../hoc/Auxilliary/Auxilliary";
import HomeIcon from "@material-ui/icons/Home";

const homeNavigation = (props) => {
  
  let inlineStyle = !props.callFrom
    ? {
        border: "none",
        backgroundColor: "transparent",
        borderColor: "white",
        marginLeft: "5px",
        borderRadius: "50px",
      }
    : {};
  return (
    <Aux>
      {!props.home ? (
        <NavLink style={{ color: 'white' }} to="/" exact>
        <Button style={inlineStyle}>
            <HomeIcon style={{ fontSize: 30 }} />
        </Button>
        </NavLink>
      ) : (
        ""
      )}
    </Aux>
  );
};
export default withRouter(homeNavigation);
